import { render, staticRenderFns } from "./SpFourModule2.vue?vue&type=template&id=a45586a4&scoped=true"
import script from "./SpFourModule2.vue?vue&type=script&lang=js"
export * from "./SpFourModule2.vue?vue&type=script&lang=js"
import style0 from "./SpFourModule2.vue?vue&type=style&index=0&id=a45586a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45586a4",
  null
  
)

export default component.exports